/*
  Work list rows (desktop): hovering a row shows the dot, darkens the text and fades in a floating card
  preview (CSS). Nothing in the row changes size, so no text moves.
  Position: centred in the empty space between the project name and the tagline. Where that space is too
  narrow for the preview (long names on small laptops), it follows the cursor sideways instead, sitting just
  right of the pointer so the name being pointed at stays readable. It never reaches the link column, so it
  can't cover "View case study" on this row or the rows above and below.
*/
(function () {
  const desktop = window.matchMedia('(min-width: 768px)');
  const MARGIN = 24; // minimum space between the preview and the text, and between the pointer and the preview

  // Edge of the text itself (not of its box), so short names and taglines leave the most room
  const textEdge = (el, side) => {
    const range = document.createRange();
    range.selectNodeContents(el);
    return range.getBoundingClientRect()[side];
  };

  document.querySelectorAll('[data-mf-work-row]').forEach((row) => {
    const preview = row.querySelector('.animated-image-wrapper');
    const name = row.querySelector('.heading-work-list > div:last-child');
    const tagline = row.querySelector('.element-flex.more-gap > div');
    const link = row.querySelector('.element-flex.more-gap > div:nth-child(2)');
    if (!preview || !name || !tagline || !link) return;
    let followCursor = false;

    const half = () => preview.offsetWidth / 2;
    const place = (centreX) => {
      const linkStart = link.getBoundingClientRect().left - row.getBoundingClientRect().left;
      const x = Math.min(Math.max(centreX, half()), linkStart - MARGIN - half());
      preview.style.left = `${x}px`;
    };
    const nextToPointer = (event) => event.clientX - row.getBoundingClientRect().left + MARGIN + half();

    row.addEventListener('mouseenter', (event) => {
      if (!desktop.matches) return;
      const rowLeft = row.getBoundingClientRect().left;
      const gapStart = textEdge(name, 'right') - rowLeft;
      const gapEnd = textEdge(tagline, 'left') - rowLeft;
      followCursor = gapEnd - gapStart < preview.offsetWidth + MARGIN * 2;
      place(followCursor ? nextToPointer(event) : (gapStart + gapEnd) / 2);
      row.classList.add('is-active');
    });
    row.addEventListener('mousemove', (event) => {
      if (followCursor && desktop.matches) place(nextToPointer(event));
    });
    row.addEventListener('mouseleave', () => row.classList.remove('is-active'));
  });
})();
